 <template>
  <transition name="Voice">
    <div class="Voice">
      <ParticlesText ref="blur"  v-if="!this.slugIsIn([ '3', '15', '31', '32' ])"/>
      <!--div class="Voice__shadow"></div-->
      <transition @enter="enter" @leave="leave" mode="out-in" appear>
        <div :key="$route.params.slug">
          <div class="Voice__txt-container">
            <div class="Voice__txt" v-html="trans('Global.voice.'+ $route.params.slug)"  v-if="!this.slugIsIn([ '3', '15', '31', '32' ])"/>
          </div>
          <div class="Btn"
            :class="['is-' + btnKey]"
            v-if="btnKey"
            @click="onClick()"
            >
              <svg v-if="btnKey == 'svg'"><use :xlink:href="'#' + require('./sprite/arrow.svg').default.id" /></svg>
              <span v-else v-html="trans('Global.btn.' + btnKey)" />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>

import '@/commons/js/gsap/SplitText'
import ParticlesText from '@/components/particles/ParticlesText'

export default {
  name: 'Voices',
  components: { ParticlesText },
  data: () => ({
    canNext: false
  }),
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKey)
  },
  mounted() {
    document.addEventListener('keydown', this.onKey)
  },
  methods: {

    onClick() {
      // this.$store.commit('app/SET_AMBIANCE', 'click')
      this.$store.commit('app/SET_AMBIANCE', 'selection')
      this.next()
    },
    onKey(event) {
      if(this.slugIsIn(['writing:1', 'writing:2'])) return

      if((event.keyCode == 13 || event.keyCode == 32) && this.btnKey && this.canNext)
        this.next()
    },
    enter(el, done) {

      const txt = el.querySelector('.Voice__txt')
      const btn = el.querySelector('.Btn')

      if(!txt && btn) {  
        const tml = new TimelineMax({ onComplete: done })
              .from(el, .25, { alpha: 0 })
              .from(btn, .5, { alpha: 0, scale: 0 })
              .to(btn, 1, { scale: .9, yoyo: true, repeat: -1 })
              .call(() => this.canNext = true)
        return
      }

      else if(!txt || !btn) {
        return done()
      }

      const delay = (this.slugIsAfter('codec')) ? .5 : .5
      const split = new SplitText(txt, { type: "words" })
      const tl = new TimelineMax({ onComplete: done, delay: delay })
			.from(el, .25, { alpha: 0 })
      .staggerFrom(split.words, .5, {
        alpha: 0,
        x: 30,
        ease: Ease.easeOut,
      }, .15)
      .from(btn, .5, { alpha: 0, scale: 0 })
      .to(btn, 1, { scale: .9, yoyo: true, repeat: -1 })
      .call(() => this.canNext = true)

      if(this.$root.isDev)
        tl.timeScale(3)
    },
    leave(el, done) {
      const txt = el.querySelector('.Voice__txt')
      const btn = el.querySelector('.Btn')

      if(!txt || !btn)
        return done()

			this.canNext = false

      TweenMax.to(txt, .5, { alpha: 0 })
      TweenMax.to(btn, .5, { alpha: 0, y: 100, onComplete: done })
    },
  },
  computed: {
    btnKey() {

      if(this.slugIsIn(['3', '15', '32']))
        return 'start'
      
      if(this.slugIsIn(['12', '16', '20', '23']))
        return 'pickup'

      if(this.slugIsIn(['33']))
        return 'continue'

      return 'svg'
    },
  }

}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Voice
  position fixed
  top 0
  left 0
  transition opacity .5s
  &-enter
  &-leave-active
    opacity 0

  .Btn
    bottom 68px
    &.is-world_call
      bottom 100px

    svg
      fill black
      width 25px

  &__txt-container
    position fixed
    width 620px
    text-align center
    bottom 0px
    left 50%
    height 180px
    transform translateX(-50%)

  &__txt
    padding 0px
    position absolute
    top 50%
    left 50%
    width 100%
    transform translate(-50%, -50%)
    font-weight 200
    text-shadow -1px 1px 3px rgba(black, .2)
    pointer-events none

    +max-screen-height(tablet-portrait)
      font-size 18px
      line-height 24px

</style>



// WEBPACK FOOTER //
// src/components/voice/Voice.vue